import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { LOGO_URL } from "../lib/api";
import { Loader2 } from "lucide-react";

export default function AdminLogin() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setErr("");
    try {
      await login(email, password);
      nav("/admin");
    } catch (e2) {
      setErr(e2.response?.data?.detail || "Accesso non riuscito");
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-5 bg-ink">
      <div className="w-full max-w-sm">
        <div className="bg-white rounded-2xl px-5 py-3 mx-auto mb-8 w-fit shadow-sm">
          <img src={LOGO_URL} alt="Fantini Next Mobility" className="h-10 w-auto object-contain" />
        </div>
        <form onSubmit={submit} className="bg-white rounded-3xl p-8 shadow-floating">
          <h1 className="font-serif text-3xl mb-1">Area riservata</h1>
          <p className="text-sm text-ink-soft mb-6">Accedi al pannello Fantini Auto</p>
          <label className="block mb-4">
            <span className="text-xs uppercase tracking-wider text-ink-soft">Email</span>
            <input data-testid="login-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required
              className="mt-1.5 w-full h-12 px-4 rounded-xl border border-border outline-none focus:border-ink" />
          </label>
          <label className="block mb-6">
            <span className="text-xs uppercase tracking-wider text-ink-soft">Password</span>
            <input data-testid="login-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required
              className="mt-1.5 w-full h-12 px-4 rounded-xl border border-border outline-none focus:border-ink" />
          </label>
          {err && <div data-testid="login-error" className="text-sm text-clay mb-4">{err}</div>}
          <button data-testid="login-submit" disabled={busy}
            className="w-full h-13 py-3.5 rounded-xl bg-ink text-white flex items-center justify-center hover:opacity-90 transition-opacity disabled:opacity-50">
            {busy ? <Loader2 className="animate-spin" size={18} /> : "Accedi"}
          </button>
        </form>
      </div>
    </div>
  );
}
